<template>
    <div v-if="priceTeaser && priceTeaser.text !== '' && priceTeaser.price !== ''" class="product-price__price-teaser">
        <div class="product-price__text">
            <span>{{ `${priceTeaser.text}: ` }}</span> <span v-html="processPriceTeaser(priceTeaser.price)"></span>
            <img src="https://www.skjewellery.com.my/api/wp-content/uploads/2023/11/flash-sale-thunder-134x300-1.png" alt="Flash Sale"/>
        </div>
        <div v-if="countdownText" class="product-price__countdown" v-html="countdownText"></div>
    </div>

    <PriceShortTerm v-if="shortTermData && shortTermData.price && shortTermData.start_date && shortTermData.end_date" :data="shortTermData"/>
    <div v-if="props.priceInfo?.sale_price !== null ">
        <div class="line-price 3333">
            <p class="price-html" dir="ltr">
                <span class="w_price" v-if="priceInfo?.regular_price != '0'">
                    <del v-if="priceInfo?.regular_price != '0' && Number(priceInfo?.sale_price) > 0 && Number(priceInfo?.regular_price) > Number(priceInfo?.sale_price)" >
                        <span class="woocommerce-Price-amount amount 99" v-html="displayCustomPrice(priceInfo?.regular_price)"></span>
                    </del>
                    <span class="single-sale-percent" v-if="Number(priceInfo?.regular_price) > 0 && Number(priceInfo?.sale_price) > 0 && Number(priceInfo?.regular_price) > Number(priceInfo?.sale_price) && Math.round(100 - (Number(priceInfo?.sale_price) / Number(priceInfo?.regular_price) * 100)) >= 5">
                        <span :data-pecent="`-${Math.round(100 - (Number(priceInfo?.sale_price) / Number(priceInfo?.regular_price) * 100))}%`"></span>
                    </span>
                    <ins v-if="Number(priceInfo?.sale_price) > 0 "><span class="woocommerce-Price-amount amount 44" v-html="displayCustomPrice(priceInfo?.sale_price)"></span></ins>
                    <ins v-else><span class="woocommerce-Price-amount amount" v-html="displayCustomPrice(priceInfo?.regular_price)"></span></ins>
                </span>

                <span class="woocommerce-Price-amount amount" v-if="priceInfo?.regular_price == '0' " v-html="displayCustomPrice(priceInfo?.sale_price)"></span>
            </p>
            <LabourCost v-if="showLabourCost" :data="props.labourData"/>
        </div>
        <!-- <div
            class="grab-price-divider-widget"
            data-min-price="0"
            data-max-price="9999"
            data-money-format="${{amount}}"
            data-currency-code="MYR"
        >
            <div class="grab_pdt_container">
            <span class="grab_pdt_left">Or 4 payments of <span v-html="displayCustomPrice((priceGrab / 4).toString())"></span> with </span>
            <span class="grab_pdt_right"
                ><img
                class="grab_pdt_logo"
                height="16px"
                src="/single-product/grab.svg"
                alt=""
                />
                <a class="grab_pdt_link" @click="openModalGrab">More info</a>
            </span>
            </div>
        </div> -->
    </div>
    <div v-else-if="props.priceInfo?.price !== undefined && !isNaN(props.priceInfo?.price)">
        <div class="line-price 2222">
            <p class="price-html" dir="ltr">
                <span class="w_price" v-if="priceInfo?.regular_price != '0'">
                    <ins><span class="woocommerce-Price-amount amount" v-html="displayCustomPrice(priceInfo?.regular_price)"></span></ins>
                </span>
            </p>
            <LabourCost v-if="showLabourCost" :data="props.labourData"/>
        </div>
        <!-- <div
            v-if="priceGrab !== '0'"
            class="grab-price-divider-widget"
            data-min-price="0"
            data-max-price="9999"
            :data-product-price="formattedPrices.regularPrice"
            data-money-format="${{amount}}"
            data-currency-code="MYR"
        >
            <div class="grab_pdt_container">
            <span class="grab_pdt_left">Or 4 payments of <span v-html="displayCustomPrice((priceGrab / 4).toString())"></span> with </span>
            <span class="grab_pdt_right"
                ><img
                class="grab_pdt_logo"
                height="16px"
                src="/single-product/grab.svg"
                alt=""
                />
                <a class="grab_pdt_link" @click="openModalGrab">More info</a>
            </span>
            </div>
        </div> -->
    </div>

    <!-- <p class="rely-description" id="rely-product-p">
        Buy Now, Pay Later Available
    </p> -->
    <p class="rely-description" id="rely-product-p" v-if="priceInfo?.price !== undefined && !isNaN(priceInfo?.price)">
        Or 4 Interest Free payments of RM{{ parseFloat((priceInfo?.price / 4).toFixed(2)) }} with
    </p> 
    <div class="payment-icons" v-if="priceInfo?.price !== undefined && !isNaN(priceInfo?.price)">
        <span
        ><img
            src="/single-product/payment_green_box.svg"
            alt="Grab" /></span
        >
    </div>
    <div :class="['grab_pdt_div_modal', { open: isModalGrabOpen }]"  @click="handleOutsideClick" >
        <div class="grab_pdt_container_modal">
            <div class="grab_pdt_action_bar"><a class="grab_pdt_action_close" @click="closeModalGrab">x</a></div>
            <div class="grab_pdt_container_row_1">
                <img src="/single-product/logograb.svg" alt="Grab">
            </div>
            <div class="grab_pdt_container_row_2">
                <p>With PayLater, get what you need now and pay later</p>
            </div>
            <div class="grab_pdt_container_row_3">
                <ul class="grab_pdt_features">
                    <li>
                        <img src="/single-product/grab01.svg" alt="Spread your bill without interest">
                        <h5>Spread your bill without interest</h5>
                        <p>With 4 monthly interest-free instalments, we give you more time to pay in smaller amounts.</p>
                    </li>
                    <li>
                        <img src="/single-product/grab02.svg" alt="No hidden charges, free to use">
                        <h5>No hidden charges, free to use</h5>
                        <p>Automatic repayments ensures you won't miss any payments.</p>
                    </li>
                    <li>
                        <img src="/single-product/grab03.svg" alt="Fast and secure Checkout in 2 taps">
                        <h5>Fast and secure Checkout in 2 taps.</h5>
                        <p>Set up in 2 minutes  without having to save card details on multiple shopping sites anymore.</p>
                    </li>
                </ul>
            </div>
            <div class="grab_pdt_container_row_4"><a class="grab_pdt_action_learnmore" href="https://www.grab.com/finance/pay-later" target="_blank">Learn more</a></div>
        </div>
    </div>
</template>

<script setup lang="ts">
    import LabourCost from "~/components/Product/SingleProduct/Layouts/LabourCost.vue"
    import PriceShortTerm from "~/components/Product/SingleProduct/Layouts/PriceShortTerm.vue";
    import { computed } from "vue";
    import { formatPriceSingleProduct } from "~/utils/formatPrice";
    import { displayCustomPrice, displayPrice } from "~/utils/displayPrice"
    
    const wooStore = useWooStore();
    const props = defineProps({
        priceInfo: {
            type: Object,
        },
        shortTermData:  {
            type: Object,
        },
        labourData: {
            type: Object,
            default: null
        },
        priceTeaser: {
            type: Object,
        }
    });

    const priceGrab = props.priceInfo?.price ?? '0';
    const showLabourCost = computed(() =>
        props.labourData && props.labourData.isLabourProduct
    );

    const isModalGrabOpen = ref(false);
    const openModalGrab = () => {
        isModalGrabOpen.value = true;
        document.body.style.overflow = 'hidden';
    };
    const closeModalGrab = () => {
        isModalGrabOpen.value = false;
        document.body.style.overflow = '';
    };

    const handleOutsideClick = (event: any) => {
        const modalContent = document.querySelector('.grab_pdt_container_modal');
        if (modalContent && !modalContent.contains(event.target)) {
            closeModalGrab();
        }
    };
    const shortTermData = props.shortTermData;

    // Compute formatted prices
    const formattedPrices = computed(() =>
        formatPriceSingleProduct({
            salePrice: props.priceInfo?.sale_price,
            regularPrice: props.priceInfo?.regular_price ?? 0,
            salePercent: props.priceInfo?.salePercent,
            currency: props.priceInfo?.currency ?? "USD",
        })
    );

    const processPriceTeaser = (price: string) => {
        const currentPrice = displayPrice(price);
        const priceStr = currentPrice.replace(/,/g, "").toString();
        const length: number = priceStr.length;
        let priceMark: string = "";
        if (length === 1) {
            priceMark =  priceStr;
        } else {
            let mask: string = priceStr[0];
            const numQuestionMarks: number = length - 1;
            for (let i = 0; i < numQuestionMarks; i++) {
                mask += '?';
            }
            priceMark = mask;
        }
        return `${wooStore.currency.symbol}${priceMark}`;
    }
    const countdownText = ref<string>('')
    let timer: ReturnType<typeof setInterval> | null = null

    function pad(num: number): string {
        return num.toString().padStart(2, "0")
    }

    function pluralize(value: number, unit: string): string {
        return value > 1 ? `${unit}s` : unit
    }

    function updateCountdown(): void {
        if (!props.priceTeaser?.countdown) return

        const targetTimeUTC = props.priceTeaser.countdown
        const targetTimeSGT = targetTimeUTC - (8 * 3600)
        const nowUTC = Math.floor(Date.now() / 1000)
        const diff = targetTimeSGT - nowUTC


        if (diff <= 0) {
            countdownText.value = ''
            if (timer) clearInterval(timer)
            return
        }

        const days = Math.floor(diff / (3600 * 24))
        const hours = Math.floor((diff % (3600 * 24)) / 3600)
        const minutes = Math.floor((diff % 3600) / 60)
        const seconds = diff % 60

        let html = ``

        if (days > 0) {
            html += `<span class="countdown-day-num">${pad(days)}</span><span class="countdown-day-text">${pluralize(days, 'Day')}</span> `
        }

        html += `
            <span>${pad(hours)}:</span><span>${pad(minutes)}:</span><span>${pad(seconds)}</span>
        `

        countdownText.value = html
    }



    onMounted(() => {
        updateCountdown()
        timer = setInterval(updateCountdown, 1000)
    })
    onUnmounted(() => {
        if (timer) clearInterval(timer)
    })

</script>